import React from 'react';
import PropTypes from 'prop-types';
import Types from './config/types';
import * as Styled from './Sizes.styles';
import { fetchById, fetchByType, errorMessage } from './tables/helpers';

var fetchTable = function fetchTable(type, id) {
  if (type) return fetchByType(type);
  if (id) return fetchById(id);
  return errorMessage;
};

var Sizes = function Sizes(_ref) {
  var type = _ref.type,
      id = _ref.id,
      dataTest = _ref['data-test'];
  return /*#__PURE__*/React.createElement(Styled.Container, {
    "data-test": dataTest
  }, type && /*#__PURE__*/React.createElement(Styled.Breadcrumbs, null, "Sizes for: ", type), fetchTable(type, id));
};

Sizes.propTypes = {
  /**
   *  Prop to request size guide data for certain types
   */
  type: PropTypes.oneOf(Types),

  /**
   * Or you can pass through the category ID and it will fetch the table for you
   */
  id: PropTypes.string,

  /**
   * Specify an optional data-test attribute to be added to your Sizes for e2e testing
   */
  'data-test': PropTypes.string
};
Sizes.defaultProps = {
  type: null,
  id: null,
  'data-test': 'component-sizes'
};
export default Sizes;